import * as d3 from 'd3-selection'
import * as array from 'd3-array'

function flatten (wrappers) {
  return array.merge(Object.keys(wrappers).map(k => wrappers[k]))
}

// Make sure first so the drawing is on top of the line
export default function (selection, gantt) {

  selection.each(function (data) {
    var vertical = d3.select(this)
                    .selectAll('line.vertical-descendants-wrapper')
                    .data(d => flatten(d._gantt.descendantWrappers))

    vertical.exit()
            .remove()

    vertical.enter()
            .insert('line', ':first-child') // Make sure it's behind the real task shape
              .merge(vertical)
              .attr('class', d => `vertical-descendants-wrapper descendants-wrapper`)
              .attr('x1', d => d.x1)
              .attr('x2', d => d.x2)
              .attr('y1', d => d.y1)
              .attr('y2', d => d.y2)

    // Draw the bottom horizontal line when the node has `lastDescendant` data
    var horizontal = d3.select(this)
                       .selectAll('line.horizontal-descendants-wrapper')
                       .data(d => d._gantt.lastDescendant ? [d._gantt.lastDescendant] : [])

    horizontal.exit()
              .remove()

    horizontal.enter()
              .append('line')
                .merge(horizontal)
                .attr('class', 'horizontal-descendants-wrapper descendants-wrapper')
                .attr('x1', d => d.x1)
                .attr('x2', d => d.x2)
                .attr('y1', d => d.y1)
                .attr('y2', d => d.y2)
  })
}
